import {
    ACCOUNT_ORDERS_RECEIVE,
    ACCOUNT_ORDERS_ERROR,
    ACCOUNT_ORDERS_LOADING,
    ACCOUNT_ORDERS_RESET,
    ACCOUNT_ORDERS_SET_ORDER,
    ACCOUNT_ORDERS_CHANGE_MODE,
    ACCOUNT_ORDERS_RECEIVE_LINES,
    ACCOUNT_ORDERS_LINES_LOADING,
    ViewMode,
} from '../constants';
import { error as errorReducer } from './Error.reducer';

const defaultLinesState = {
    orderLines: [],
    linesTotalCount: 0,
    linesPageSize: 20,
    linesLoading: false,
};

const defaultState = {
    list: [],
    loading: false,
    loaded: false,
    totalCount: 0,
    pageSize: 20,
    errors: {},
    mode: ViewMode.List,
    selectedOrder: null,
    ...defaultLinesState,
};

export const accountOrders = (state = defaultState, action) => {
    const { type, payload } = action;
    switch (type) {
        case ACCOUNT_ORDERS_RESET:
            return {
                ...defaultState,
            };
        case ACCOUNT_ORDERS_LOADING:
            return {
                ...state,
                loading: payload.loading,
            };
        case ACCOUNT_ORDERS_RECEIVE:
            return {
                ...state,
                list: payload.orders,
                loading: false,
                loaded: true,
                totalCount: payload.totalCount,
                pageSize: payload.pageSize,
                errors: {},
            };
        case ACCOUNT_ORDERS_ERROR:
            return {
                ...state,
                loading: false,
                loaded: true,
                errors: errorReducer(state.errors, action),
            };
        case ACCOUNT_ORDERS_SET_ORDER:
            return {
                ...state,
                selectedOrder: payload.order,
                ...defaultLinesState,
            };
        case ACCOUNT_ORDERS_CHANGE_MODE:
            return {
                ...state,
                mode: payload.mode,
                ...(payload.mode === ViewMode.List ? defaultLinesState : {}),
            };
        case ACCOUNT_ORDERS_RECEIVE_LINES:
            return {
                ...state,
                orderLines: payload.lines,
                linesTotalCount: payload.totalCount,
                linesPageSize: payload.pageSize,
                linesLoading: false,
            };
        case ACCOUNT_ORDERS_LINES_LOADING:
            return {
                ...state,
                linesLoading: payload.loading,
            };
        default:
            return state;
    }
};
